var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTictok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8491 7.78289C15.702 7.79686 15.5543 7.80434 15.4062 7.80534C13.7851 7.80534 12.2738 6.98832 11.3859 5.6321V13.0312C11.3859 16.0519 8.93684 18.5 5.91714 18.5C2.89644 18.5 0.448364 16.0519 0.448364 13.0312C0.448364 10.011 2.89644 7.56293 5.91714 7.56293C6.03087 7.56293 6.1426 7.57291 6.25483 7.57989V10.2749C6.1426 10.2614 6.03236 10.241 5.91714 10.241C4.37537 10.241 3.12588 11.4909 3.12588 13.0317C3.12588 14.5735 4.37537 15.823 5.91714 15.823C7.45892 15.823 8.82013 14.6084 8.82013 13.0666L8.84756 0.5H11.4258C11.6687 2.81191 13.5327 4.61805 15.8516 4.78764V7.78289",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTictok);
export default __webpack_public_path__ + "static/media/tictok.d00b82c3f6746bc80f1fc4ecbb3f7537.svg";
export { ForwardRef as ReactComponent };